var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"signOut",attrs:{"title":"Sign out of current login"},on:{"click":function($event){return _vm.signOut()}}},[_c('strong',[_vm._v(_vm._s(_vm.fullName)+" "),_c('br')]),_c('small',[_vm._v(_vm._s(_vm.username)+" "),_c('br'),_vm._v(" Sign Out")])])
}
var staticRenderFns = []

export { render, staticRenderFns }